import React, { useContext } from "react";
import { Link } from "react-router";
import { UserX, User } from "lucide-react";
import { isEmpty } from "lodash";
import { Button } from "./ui/button";
import UserMenu from "./UserMenu";
import useFakeUID from "../hooks/useFakeUID";

import { AuthContext } from "../helpers/Auth";

const LoginButton = () => {
  const { currentUser } = useContext(AuthContext) ?? {};
  const fakeUID = useFakeUID();
  const triggerComponent = fakeUID ? (
    <UserX className="h-5 w-5" />
  ) : currentUser && currentUser.photoURL ? (
    <img src={currentUser.photoURL} alt="" referrerPolicy="no-referrer" className="h-6 w-6 rounded-full" />
  ) : (
    <User className="h-5 w-5" />
  );

  if (currentUser && !isEmpty(currentUser) && currentUser.uid) {
    return <UserMenu trigger={triggerComponent} />;
  } else {
    return (
      <Link to="/login">
        <Button size="sm">Login</Button>
      </Link>
    );
  }
};

export default LoginButton;
